import { useFormContext } from '../form/FormContext';
import { useField } from './useField';

export function useFieldStatesClassNames<T = unknown>(
  name: string,
  formName?: string,
): string {
  const { error, isTouched } = useField<T>({
    name,
    formName,
    avoidRegisterIfExists: true,
    removeOnUnmount: false,
  });
  const { avoidFieldsTouch } = useFormContext();
  if (error) return 'error';
  if (!avoidFieldsTouch && isTouched) return 'touched';
  return '';
}
